const fonts = {
  small: '12px',
  default: '14px',
  title: '17px',
  large: '20px',
  xlarge: '22px',
};
export default fonts;
